export default __webpack_public_path__ + "static/media/amex.3e27ff95.svg";